/**
 * setSessionAreaName
 *
 * Sets the current session area name.
 *
 * Writes to Redux state (via `switchArea` action) — keeps the debounced
 * localStorage persist and backward compat with remaining Redux consumers.
 *
 * Note: Requires a non-empty string because the underlying `switchArea`
 * action does not support clearing the area name.
 */
import { getStore } from '@/store/store-proxy';
import { switchArea } from '@/store/slices/sessionSlice';
export const setSessionAreaName = (areaName) => {
    getStore().dispatch(switchArea(areaName));
};
